<template>
  
  <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li
          class="tabLi"
          v-for="(data,$index) in langData"
          :key="$index"
          :class="{'active':$index==0}"
        >
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a
            :class="true?'tab'+$index:''"
            data-toggle="tab"
            :href="true?'#tab-'+$index:''"
            aria-expanded="true"
            @click="showTab($event,$index)"
          >{{ $t("message." + data) }}</a>
        </li>
      </ul>
    </div>
    <el-form  :model="descDetail" ref="descDetail"  label-width="0px" class="demo-dynamic form-horizontal detailPage">

      <div class="tab-content">
        <div
          :id="'tab-'+index"
          v-for="(langItem, index) in descDetail.langMap"
          :key="index"
          class="tab-pane"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Short Description
                </label>
                <div class="col-sm-10" >
                  <div>
                    <el-input v-model="langItem.shortDescription1" show-word-limit :maxlength="langItem.langCode=='en_US'?90:45" ></el-input>
                  </div>
                </div>
              </div>
              <!-- <div class="form-group">
                <label class="col-sm-2 control-label">
                  Short Description Line 2
                </label>
                <div class="col-sm-10" >
                  <div>
                    <el-input v-model="langItem.shortDescription2" show-word-limit :maxlength="langItem.langCode=='en_US'?36:20" ></el-input>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Short Description Line 3
                </label>
                <div class="col-sm-10" >
                  <div>
                    <el-input v-model="langItem.shortDescription3" show-word-limit :maxlength="langItem.langCode=='en_US'?36:20" ></el-input>
                  </div>
                </div>
              </div> -->
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Long Description
                </label>
                <div class="col-sm-10" >
                  <div>
                    <ckeditor :editor="editor"  @ready="onReady" v-model="langItem.longDescription" :config="editorConfig" ></ckeditor>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group" >
                <el-collapse  v-model="activeNamesBasis">
                  <el-collapse-item title="Visuals" name="4">
                    <div class="col-sm-12">
                        
                        <draggable  class="sortable-list agile-list"
                      v-model="descDetail.visualData" 
                      @start="drag=true" 
                      @end="drag=false"
                                style="max-height: 600px;overflow: auto;margin-bottom: 15px;">
                            <li class=""  v-for="(urlItem,i) in descDetail.visualData" >
                                <div class="row margin-0" style="padding: 0px !important;">
                                    <div class="form-group margin-0" v-if="urlItem.visualType=='video'">
                                        <label class="col-sm-2 control-label" >Video URL Field</label>
                                        <div class="col-sm-10">
                                            <div class="pad-t-7">
                                                {{getObject(urlItem.langMap,'en_US').image}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group margin-0" v-else>
                                        <label class="col-sm-2 control-label" >Image</label>
                                        <div class="col-sm-10">
                                            <div class="pad-t-7 col-sm-3">
                                                <img style="width: 100%;" v-bind:src="getObject(urlItem.langMap,'en_US').image"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                 <a class="pull-right btn btn-xs btn-white btnDelete" v-if="!urlItem.synchro" @click="deleteObj(descDetail.visualData,i)"><i class="fa fa-trash-o" ></i></a>
                                 <a class="pull-right btn btn-xs btn-white btnEdit"  v-if="!urlItem.synchro" @click="editObj(descDetail.visualData,4,i)"><i class="fa fa-pencil"></i></a>
                            </li>
                        </draggable>
                    </div>
                    <div class="col-sm-12 text-right pad-b-15" >
                        <div class="btn btn-primary" @click="addGroupEvent(descDetail.visualData,4)">Add</div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div class="btn btn-primary" v-if="checkPermission('TRANSPORTATION_SAVE')" @click="checkEvent()">{{$t("message.Save") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import fileupload from "../components/common/fileupload";
import eventBus from "../eventbus";
import config from "../config";
import draggable from 'vuedraggable'

import ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
export default {
  mixins: [config.globalMixin],
  data() {
    return {
      descDetail:{
        venue:"Xiqu Centre",
        visualData:[],
        langMap:[{
          shortDescription1:"",
          shortDescription2:"",
          shortDescription3:"",
          longDescription:"",
          langCode:'en_US'
        },{
          shortDescription1:"",
          shortDescription2:"",
          shortDescription3:"",
          longDescription:"",
          langCode:'zh_CN'
        },{
          shortDescription1:"",
          shortDescription2:"",
          shortDescription3:"",
          longDescription:"",
          langCode:'zh_HK'
        }],
      },
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [  'bold', 'italic','underline','Link', 'bulletedList', 'numberedList' ],
         // extraPlugins: [ upload.MyCustomUploadAdapterPlugin ]
          // The configuration of the editor.
      },
      activeNamesBasis:['4'],
    };
  },
  computed:{
      _language(){
        return this.$store.state.userInfo.langCode
      }
  },
  watch: {
    _language:function(){
      this.setObj();
    },
    descDetail: {
        handler: function(val, oldval) {
          this.$store.state.edit = true;
        },
        deep: true
    }
  },
  components: {
    draggable,
    "file-upload": fileupload
  },
  created() {
    this.setObj();
    this.init();
    this.visualTypeObj=[{
      value: 'video',
      label: 'video'
    }, {
      value: 'image',
      label: 'image'
    }]
  },
  mounted() {
    setTimeout(function(){
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    })
  },
  methods: {
    onReady( editor )  {
        // Insert the toolbar before the editable area.
        editor.ui.getEditableElement().parentElement.insertBefore(
            editor.ui.view.toolbar.element,
            editor.ui.getEditableElement()
        );
    },
    setObj:function(){
    },
    editObj: function(obj,type,index){
        this.addGroupEvent(obj,type,index);
    },
    deleteObj: function(obj,index){
        obj.splice(index,1);
    },
    addGroupEvent:function(obj,objType,index){
      var that = this;
        if(index!=undefined){
            var data = obj[index];
        }else if(objType==4){
          var data ={
                visualType:"",
                langMap:[
                {
                    "langCode":"en_US",
                    "image":"",
                },
                {
                    "langCode":"zh_CN",
                    "image":"",
                },
                {
                    "langCode":"zh_HK",
                    "image":"",
                }]
          }
        }

        this.$store.commit("setgroup", {
          obj: data,
          objType: objType,
          altText:true,
          index: index,
          boolean: true,
          callback:function(){
            that.$store.commit("setgroup", { string: "", boolean: false });
            if(index==undefined){

                obj.push(data)
            }
          }
        });
    },
    async init() {
        let obj = this.getAuthObj();
        obj.venue = "Xiqu Centre";
        obj.apiUrl = '/getVenueDescription'
        let data = await this.$store.dispatch("apiEvent", obj);
        if(!data) return;
        
        if(data.data.result==null){
          data.data.result = {
            venue:"Xiqu Centre",
            visualData:[],
            langMap:[{
              shortDescription1:"",
              shortDescription2:"",
              shortDescription3:"",
              longDescription:"",
              langCode:'en_US'
            },{
              shortDescription1:"",
              shortDescription2:"",
              shortDescription3:"",
              longDescription:"",
              langCode:'zh_CN'
            },{
              shortDescription1:"",
              shortDescription2:"",
              shortDescription3:"",
              longDescription:"",
              langCode:'zh_HK'
            }],
          }
        }
        this.descDetail = data.data.result;
        var that = this;
        setTimeout(function(){
          that.$store.state.edit = false;
        },500)
    },
    checkEvent:function(){
        this.$refs["descDetail"].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            this.$toastr.w(this.$i18n.t("message.fillRequired"));
            return false;
          }
        });
    },
    async submit() {
      try {
        let obj = this.getAuthObj();
        for(var key in this.descDetail){
          var detail = JSON.stringify(this.descDetail[key])
          obj[key] = JSON.parse(detail);
        }
        obj.visualData = JSON.stringify(obj.visualData);
        obj.langMap = JSON.stringify(obj.langMap);
        obj.apiUrl = '/saveVenueDescription'
        let data = await this.$store.dispatch("apiEvent", obj);
        if(!data) return;
        if (data.data.errorCode === 0) {
          this.$store.state.edit = false;
          this.$toastr.s("Success");
        }
      } catch (err) {
      }
    },
    langLabel(lang) {
      if (lang === "en_US") {
        return "EN";
      } else if (lang === "zh_HK") {
        return "T. Chi.";
      } else if (lang === "zh_CN") {
        return "S. Chi.";
      }
    },
    changeTab: function(id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
    showTab: function($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    }
  }
};
</script>
